<template>
  <AuthShell ref="auth" mode="account">
    <el-form :disabled="submitting || codeBusy" :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent="submitForm('ruleForm')">
      <label class="auth-label" for="login-account">账号</label>
      <el-form-item prop="username"><el-input id="login-account" v-model="ruleForm.username" type="text" autocomplete="username" placeholder="请输入手机账号" /></el-form-item>
      <label class="auth-label" for="login-password">密码</label>
      <el-form-item prop="password"><el-input id="login-password" v-model="ruleForm.password" type="password" autocomplete="current-password" placeholder="请输入登录密码" show-password /></el-form-item>
      <div class="auth-options"><el-checkbox v-model="rememberPassword" @change="rememberChanged">记住密码</el-checkbox><router-link to="/forgetpwd">忘记密码？</router-link></div>
      <el-button :loading="submitting" :disabled="submitting" type="primary" class="auth-submit" native-type="submit">登录</el-button>
    </el-form>
  </AuthShell>
</template>

<script>
import AuthShell from './AuthShell.vue'
import authSecurity from '@/utils/authSecurity'
import { resetAnnouncementForLogin } from '@/utils/homeAnnouncement'
import { setCath,setCathString } from '@/utils/cache'
import {apiLogin} from '@/utils/requestapis'
import { readRememberedCredentials, saveRememberedCredentials, clearRememberedCredentials } from '@/utils/rememberCredentials'

export default {
  components: { AuthShell },
  mixins: [authSecurity],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号'));
      } else if (value.length < 11) {
        callback(new Error('请输入完整的手机账号'));
      } else {
        callback();
      }
    };
    return {
      rememberPassword: false,
      codeBusy:false,
      activeName:'first',
      ruleForm: {
        password: '',
        username: '',
      },
      rules: {
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        username: [
          { validator: validateUsername, trigger: 'blur' }
        ]
      }
    };
  },
  async mounted() {
    const credentials = await readRememberedCredentials()
    if (this._isDestroyed || !credentials || this.ruleForm.username || this.ruleForm.password) return
    Object.assign(this.ruleForm, credentials)
    this.rememberPassword = true
  },
  methods: {
    rememberChanged(checked) {
      if (!checked) clearRememberedCredentials()
    },
    handleClick(){
      this.$router.push('/Logincode').catch(err=>{})
    },
    async submitForm(formName) {
      if (this.submitting || this.codeBusy) return
      this.submitting = true
      try {
        const valid = await new Promise(resolve => this.$refs[formName].validate(resolve))
        //console.log(this.ruleForm);
        if (valid) {
          const captcha = await this.prepareLogin(this.ruleForm.username).catch(() => null)
          if (captcha === null) { this.submitting = false; return }
          const credentials = { ...this.ruleForm }
          await apiLogin({ ...credentials, captcha_code: captcha }).then(async (res) => {
            res = await this.$refs.auth.completeLogin(res)
            if(res && res.token){
              try {
                if (this.rememberPassword) await saveRememberedCredentials(credentials)
                else clearRememberedCredentials()
              } catch (_) { this.$message.warning('登录成功，但账号密码未能保存，请重新勾选后重试') }
              setCathString('TOKEN',res.token)
              setCath('userInfo',res)
              resetAnnouncementForLogin()
              this.$router.push('/').catch(err=>{})
            }

          }).catch(() => {})
        } /*else {
          console.log('error submit!!');
          return false;
        }*/
      } finally { this.submitting = false }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
